import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StripeTerminalSignalRService {

  private hubConnection: signalR.HubConnection;
  private stripeResponseSubject = new Subject<any>();
  public stripeResponse$ = this.stripeResponseSubject.asObservable();
  public connectionId: string = '';

  public startConnection(baseUrl): Promise<void> {
    // Stop any existing connection before creating a new one to avoid leaking handles.
    const stopFirst: Promise<void> =
      this.hubConnection &&
      this.hubConnection.state !== signalR.HubConnectionState.Disconnected
        ? this.hubConnection.stop().catch(() => {})
        : Promise.resolve();

    return stopFirst.then(() => {
      baseUrl = baseUrl.replace('/api', '/');
      this.hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(baseUrl + 'StripePaymentHub')
        .build();

      return this.hubConnection
        .start()
        .then(() => {
          console.log('SignalR connection started');
          const id = this.hubConnection.connectionId;
          if (!id) {
            throw new Error('SignalR connectionId is unavailable after connection start.');
          }
          this.connectionId = id;
        });
      // No .catch here — let callers handle errors so they can reset UI state.
    });
  }

  public getConnectionId(): string {
    return this.connectionId;
  }

  public addStripeResponseListener(listenerString : string): void {
    this.hubConnection.on(listenerString, (response : any) => {
      console.log('Stripe response received:', response);
      this.stripeResponseSubject.next(response);
    });
  }

  public stopConnection(): void {
    this.connectionId = '';
    if (this.hubConnection && this.hubConnection.state === signalR.HubConnectionState.Connected) {
      this.hubConnection.stop()
      .then(() => console.log('SignalR connection stopped'))
      .catch(err => console.error('Error while stopping SignalR connection: ' + err));
    }else{
      console.log('No active SignalR connection to stop');
    }
  }
}
